<app-table
  [data]="usedCouponsData"
  [displayedColumns]="usedCouponsColumns"
  [type]="TableType.USED_COUPON_DETAILS"
  pageTitle="admin_page.header_item.used_coupons"
  [loading]="!isDataLoaded"
  (selectionEmitter)="triggerSelection($event)"
></app-table>
